<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Website Traffic Stats
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/reporting"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>

    <div
      v-if="!loading && stats.length > 0"
      class="statboxes"
    >
      <div
        v-for="(statRow, rowIndex) in statRows"
        :key="rowIndex"
        class="statbox_row"
      >
        <div
          v-for="(stat, statIndex) in statRow"
          :key="statIndex"
          class="stat_cards white_box"
        >
          <div class="stats">
            <div class="stat">
              {{ stat.value > 0 ? stat.value.toLocaleString() : 0 }}{{ stat.suffix }}
            </div>
            <div class="source">
              Source:<br>{{ stat.source }}
            </div>
          </div>
          <div class="p_body stat_title">
            {{ stat.title }}
            <small :class="stat.difference > 0 ? 'positive' : 'negative'">
              ({{ (stat.difference > 0 ? '+' : '') + (Math.round(stat.difference * 1000) / 10) }}% MoM)
            </small>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="stats.length === 0 && !error"
      class="loading_widget_data"
    >
      <div v-if="loading">
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>
      <div v-else>
        No Data
      </div>
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import _ from 'lodash';

export default {
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      stats: [],
      loading: true,
      error: ''
    }
  },
  computed: {
    ...mapState('dashboard', [
      'activeWebsite',
      'trafficData',
      'preview',
      'trafficDataError',
    ]),
    ...mapState('user', ['user']),
    statRows() {
      let rows = [];
      let chunk = 2;
      for (let i = 0; i < this.stats.length; i += chunk) {
        rows.push(this.stats.slice(i, i + chunk));
      }
      return rows;
    }
  },
  watch: {
    trafficData: {
      handler() {
        this.setData();
      },
      deep: true
    },
    trafficDataError: {
      handler() {
        if (this.trafficDataError) {
          this.error = `
                        <i class="fa fa-btn fa-exclamation-triangle"></i>
                        <span>There's a problem with your account connection. </span>
                        <a href="/website/settings/${this.activeWebsite.hash_id}">Go to settings</a>
                    `;
          this.loading = false;
        }
      }
    }
  },
  mounted() {
    if (this.trafficData?.cards) {
      this.setData();
    }
  },
  methods: {
    setData() {
      if (!this.activeWebsite.has_ga_connection && !this.activeWebsite.has_gsc_connection) {
        this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>Please connect to Google Analytics.</span> ${this.user ? `<a href="/website/settings/${this.user.active_website.hash_id}">Go to settings</a>` : ''}`;
        this.loading = false;
        return;
      }
      this.stats = [];
      _.each(this.trafficData.cards, (card) => {
        if (card.data) {
          if (card.source === 'Google Analytics' && !this.activeWebsite.has_ga_connection) return true;
          if (card.source === 'Google Search Console' && !this.activeWebsite.has_gsc_connection) return true;
          let card_stat = {
            title: card.title,
            value: card.data.count,
            source: card.source,
            difference: (card.data.count - card.data.comp_count) / card.data.comp_count,
            suffix: card.suffix
          };
          this.stats.push(card_stat);
        }
      });
      this.loading = false;
    }
  },
}
</script>

<style scoped>
.statboxes {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.statbox_row {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.stat_cards {
  width: 50%;
  margin: 0;
  border: 1px solid #E8E5E2;
}

.positive {
  color: var(--primary-color);
}

.negative {
  color: var(--negative-color);
}
</style>
